const IllustrationItalyBilling = () => {
  return (
    <svg
      width="248"
      height="160"
      viewBox="0 0 248 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M50.5814 140.628C50.9116 140.183 51.3335 139.813 51.8189 139.543C52.2318 139.331 52.5851 139.02 52.8471 138.639C53.0358 138.127 53.083 137.574 52.9836 137.038C52.878 136.744 52.8338 136.432 52.8537 136.121C52.8737 135.81 52.9574 135.506 53.0996 135.229C53.2419 134.951 53.4398 134.705 53.6812 134.506C53.9225 134.307 54.2022 134.159 54.5032 134.071C54.7719 133.98 55.0172 133.832 55.222 133.637C55.5132 133.284 55.3858 132.733 55.222 132.072C55.0737 131.802 54.9887 131.502 54.9734 131.195C54.9581 130.887 55.0128 130.58 55.1336 130.297C55.2543 130.013 55.4379 129.76 55.6706 129.557C55.9034 129.354 56.1792 129.206 56.4777 129.124C56.6448 129.066 56.8062 128.994 56.9599 128.907C57.2306 128.717 57.4486 128.463 57.5934 128.167C57.7382 127.871 57.8051 127.544 57.788 127.215C57.7021 126.298 57.4686 125.4 57.0964 124.556H55.5223C54.1028 124.556 52.6742 124.475 51.2548 124.556C50.545 124.556 49.8353 124.556 49.1255 124.62L48.0518 124.674C47.697 124.674 47.3421 124.674 46.9872 124.755L48.0518 124.828L49.1255 124.882L50.8908 124.945L50.3539 126.067C49.7261 126.067 49.0892 126.067 48.4522 126.13L47.3876 126.175L46.323 126.257V126.311L47.3876 126.392L48.4522 126.447C49.0164 126.447 49.5896 126.447 50.1538 126.501L49.6169 127.622L47.7971 127.686L46.7325 127.74L45.6678 127.821V127.867L46.7325 127.939L47.7971 127.993L49.4349 128.047L48.8981 129.178L47.1328 129.232L46.0682 129.287C45.7133 129.287 45.3494 129.332 44.9945 129.368V129.413C45.3494 129.413 45.7133 129.467 46.0682 129.495L47.1328 129.549C47.6515 129.549 48.1792 129.549 48.6979 129.603L48.1701 130.725C47.5241 130.725 46.878 130.725 46.2411 130.788L45.1765 130.842C44.8125 130.842 44.4577 130.887 44.1028 130.924V130.969L45.1765 131.041L46.2411 131.095C46.8113 131.095 47.3846 131.114 47.9608 131.15L47.4422 132.253C46.8144 132.253 46.1956 132.253 45.5678 132.316L44.5032 132.371L43.4386 132.443V132.488L44.5032 132.57L45.5678 132.624C46.1228 132.624 46.687 132.669 47.242 132.678L46.7052 133.809L44.8853 133.863L43.8116 133.917L42.747 133.999V134.044L43.8116 134.125L44.8853 134.171C45.4131 134.171 45.9499 134.216 46.4868 134.225L45.959 135.355C45.3039 135.355 44.6487 135.355 43.9936 135.419L42.9199 135.473L41.8553 135.545C42.2102 135.545 42.565 135.6 42.9199 135.627L43.9936 135.681C44.5759 135.681 45.1674 135.726 45.7498 135.735L45.222 136.857L43.3203 136.92L42.2557 136.974L41.182 137.056L42.2557 137.137L43.3203 137.182C43.8844 137.182 44.4486 137.182 45.0127 137.246L44.485 138.367C43.8753 138.367 43.2657 138.367 42.6651 138.431L41.6005 138.485L40.5359 138.557V138.602L41.6005 138.684L42.6651 138.738L44.303 138.792L43.7661 139.923C43.1747 139.923 42.5832 139.923 42.0009 139.977L40.9363 140.031C40.5814 140.031 40.2174 140.031 39.8626 140.113C40.2174 140.113 40.5814 140.167 40.9363 140.185L42.0009 140.239C42.5195 140.239 43.0382 140.239 43.5659 140.294L43.0291 141.424C42.3921 141.424 41.7461 141.424 41.1092 141.488L40.0446 141.542L38.9709 141.614V141.659C39.3257 141.659 39.6806 141.714 40.0446 141.741L41.1092 141.795L42.8289 141.849L42.2921 142.971L40.4722 143.025L39.4076 143.07C39.0528 143.07 38.6979 143.07 38.343 143.152C38.6979 143.152 39.0528 143.206 39.4076 143.233L40.4722 143.287L42.1283 143.351H50.363C50.127 142.445 50.2039 141.486 50.5814 140.628Z"
          fill="#9FAFBC"
        />
        <path
          d="M185.177 140.945C184.911 140.607 184.58 140.324 184.203 140.113C183.652 139.817 183.19 139.379 182.866 138.847C182.591 138.189 182.509 137.468 182.629 136.766C182.684 136.052 182.729 135.437 182.338 135.066C182.137 134.905 181.909 134.779 181.665 134.695C181.254 134.556 180.884 134.317 180.591 133.999C180.377 133.654 180.246 133.265 180.208 132.862C180.171 132.459 180.227 132.052 180.373 131.674C180.527 130.924 180.6 130.435 180.318 130.119C180.129 129.952 179.905 129.828 179.663 129.757C179.449 129.679 179.241 129.582 179.044 129.467C178.656 129.198 178.343 128.835 178.133 128.413C177.923 127.991 177.823 127.523 177.843 127.053C177.894 126.215 178.069 125.389 178.362 124.602H176.742L172.475 124.71H64.0397L59.7722 124.62H58.0433C58.4058 125.443 58.6272 126.32 58.6985 127.215C58.7175 127.685 58.6165 128.152 58.4049 128.573C58.1933 128.994 57.8779 129.354 57.4883 129.621C57.2943 129.736 57.0902 129.833 56.8787 129.911C56.6374 129.985 56.4143 130.108 56.2235 130.272C55.9323 130.589 56.0142 131.077 56.1689 131.837C56.3074 132.215 56.3597 132.619 56.3219 133.019C56.2842 133.42 56.1573 133.807 55.9505 134.153C55.6554 134.469 55.2867 134.708 54.8768 134.849C54.6298 134.933 54.3991 135.059 54.1944 135.22C53.8122 135.591 53.8577 136.206 53.9123 136.92C54.0248 137.622 53.943 138.341 53.6757 139C53.3512 139.533 52.8894 139.97 52.3382 140.267C51.9599 140.475 51.6285 140.758 51.3646 141.099C51.0097 141.632 51.0643 142.365 51.219 143.532H185.305C185.486 142.175 185.532 141.46 185.177 140.945Z"
          fill="#C3CDD5"
        />
        <path
          d="M198.262 143.288C197.907 143.288 197.552 143.233 197.197 143.206L196.132 143.161L194.267 143.107L193.739 141.985L195.459 141.931L196.524 141.877L197.588 141.795V141.75L196.524 141.678L195.459 141.623C194.822 141.623 194.176 141.569 193.539 141.56L193.002 140.43C193.521 140.43 194.049 140.43 194.567 140.375L195.632 140.321C195.987 140.321 196.342 140.321 196.697 140.249C196.342 140.249 195.987 140.194 195.632 140.167L194.567 140.113C193.976 140.113 193.394 140.068 192.802 140.059L192.265 138.928C192.811 138.928 193.357 138.928 193.894 138.874L194.968 138.82L196.032 138.738V138.693L194.968 138.621L193.894 138.566C193.284 138.566 192.675 138.521 192.074 138.503L191.537 137.382C192.101 137.382 192.675 137.382 193.239 137.318L194.303 137.273C194.658 137.273 195.013 137.273 195.368 137.192C195.013 137.192 194.658 137.137 194.303 137.11L193.239 137.056L191.337 136.993L190.809 135.871C191.392 135.871 191.983 135.871 192.566 135.817L193.63 135.763C193.985 135.763 194.349 135.763 194.704 135.681L193.63 135.609L192.566 135.555C191.91 135.555 191.255 135.5 190.6 135.491L190.072 134.361L191.674 134.306L192.738 134.261L193.812 134.18V134.135L192.738 134.053L191.674 133.999L189.854 133.945L189.317 132.814C189.875 132.814 190.43 132.796 190.982 132.76L192.056 132.706L193.121 132.624V132.579L192.056 132.507L190.982 132.452C190.364 132.452 189.736 132.452 189.117 132.389L188.589 131.286C189.172 131.286 189.745 131.286 190.318 131.231L191.383 131.177L192.447 131.105V131.06L191.383 130.978L190.318 130.924C189.672 130.924 189.035 130.924 188.389 130.861L187.852 129.739L189.426 129.685L190.491 129.631L191.556 129.549V129.504L190.491 129.422L189.426 129.368L187.652 129.314L187.115 128.183L188.753 128.129L189.827 128.075L190.891 128.003V127.957L189.827 127.876L188.753 127.822L186.933 127.758L186.405 126.637L188.107 126.583L189.172 126.528L190.236 126.447V126.311L189.172 126.23L188.107 126.185C187.47 126.185 186.833 126.13 186.196 126.121L185.668 125L187.434 124.936L188.498 124.882L189.572 124.81C189.217 124.81 188.853 124.756 188.498 124.728L187.434 124.674C186.724 124.674 186.014 124.62 185.304 124.611C183.876 124.611 182.456 124.611 181.037 124.611H179.335C179.033 125.404 178.843 126.235 178.771 127.08C178.754 127.396 178.815 127.712 178.95 127.999C179.085 128.286 179.289 128.536 179.545 128.726C179.697 128.815 179.859 128.887 180.027 128.943C180.397 129.063 180.733 129.268 181.01 129.54C181.245 129.88 181.393 130.272 181.441 130.682C181.488 131.092 181.434 131.507 181.283 131.892C181.146 132.516 181.028 133.104 181.283 133.456C181.487 133.652 181.733 133.8 182.001 133.89C182.336 134.018 182.644 134.205 182.911 134.442C183.182 134.776 183.374 135.167 183.471 135.585C183.569 136.004 183.571 136.438 183.475 136.857C183.376 137.393 183.423 137.946 183.612 138.458C183.872 138.838 184.222 139.148 184.631 139.362C185.117 139.639 185.542 140.011 185.878 140.457C186.369 141.198 186.342 142.094 186.151 143.568H194.413L196.096 143.496L197.161 143.441C197.515 143.441 197.87 143.441 198.225 143.36L198.262 143.288Z"
          fill="#9FAFBC"
        />
      </g>
      <g clipPath="url(#clip0_6154_90081)">
        <path
          d="M165.595 64.6617H160.233C160.176 64.9903 160.12 65.3188 160.071 65.6004C159.794 65.4832 159.497 65.4384 159.203 65.4693C158.909 65.5001 158.624 65.6059 158.369 65.779C158.114 65.9522 157.895 66.1885 157.727 66.4712C157.558 66.754 157.446 67.0763 157.397 67.4153C157.347 67.7543 157.363 68.1018 157.442 68.4331C157.52 68.7645 157.661 69.0716 157.853 69.3328C158.045 69.594 158.284 69.8028 158.553 69.9445C158.822 70.0863 159.115 70.1575 159.41 70.153H159.459C159.555 71.9553 161.071 72.1618 162.934 72.1618C164.796 72.1618 166.417 71.9552 166.417 69.984C166.417 69.5335 166.03 67.1868 165.595 64.6617ZM159.531 69.1392H159.41C159.109 69.1392 158.82 68.9998 158.606 68.7516C158.393 68.5034 158.273 68.1667 158.273 67.8157C158.273 67.4647 158.393 67.128 158.606 66.8798C158.82 66.6316 159.109 66.4921 159.41 66.4921C159.581 66.4941 159.75 66.5423 159.902 66.633C159.749 67.6561 159.612 68.5197 159.531 69.1392ZM157.822 67.8251C157.822 67.3272 157.992 66.8497 158.294 66.4976C158.597 66.1455 159.007 65.9477 159.434 65.9477C159.633 65.9477 159.831 65.9923 160.015 66.0792C159.833 65.9924 159.639 65.9477 159.443 65.9477C159.03 65.9477 158.634 66.1386 158.342 66.4783C158.05 66.8181 157.886 67.2789 157.886 67.7594C157.886 68.2398 158.05 68.7006 158.342 69.0404C158.634 69.3801 159.03 69.571 159.443 69.571H159.507H159.451C159.039 69.577 158.641 69.3995 158.338 69.0749C158.035 68.7503 157.851 68.3031 157.822 67.8251Z"
          fill="#BED733"
        />
      </g>
      <g clipPath="url(#clip1_6154_90081)">
        <path
          d="M105.94 66.294L106.78 72.3468C106.78 72.3468 106.905 72.8086 108.711 72.8086C110.516 72.8086 111.07 72.3468 111.07 72.3468L111.964 66.294C111.964 66.294 111.964 65.7651 109.122 65.7651C106.28 65.7651 105.94 66.294 105.94 66.294Z"
          fill="#00819D"
        />
        <path
          d="M107.09 61.8036L106.567 61.87L107.863 70.8715L108.386 70.8051L107.09 61.8036Z"
          fill="#9BE1FF"
        />
        <path
          d="M109.688 62.3107L109.16 62.3035L109.019 71.3859L109.546 71.3932L109.688 62.3107Z"
          fill="#9BE1FF"
        />
        <path
          d="M109.389 71.0082L109.912 71.0746L111.207 62.0731L110.685 62.0067L109.389 71.0082Z"
          fill="#BED733"
        />
        <path
          d="M108.173 69.8416L108.7 69.8344L108.559 60.7519L108.031 60.7592L108.173 69.8416Z"
          fill="#BED733"
        />
        <path
          d="M105.94 66.2941L106.78 72.3469C106.78 72.3469 106.905 72.8086 108.711 72.8086C110.516 72.8086 111.07 72.3469 111.07 72.3469L111.964 66.2941C111.964 66.2941 111.785 66.7054 108.934 66.7054C106.083 66.7054 105.94 66.2941 105.94 66.2941Z"
          fill="#64CEFB"
        />
      </g>
      <g clipPath="url(#clip2_6154_90081)">
        <path
          d="M118.845 54.3694C118.845 54.3694 116.726 42.1119 116.935 35.6368C117.275 24.8182 119.124 23.6102 119.124 23.6102C119.124 23.6102 119.699 39.767 119.455 46.1089C119.294 51.0477 119.503 55.9918 120.083 60.8979L118.845 54.3694Z"
          fill="#006A85"
        />
        <path
          d="M120.388 66.2804C120.181 62.9202 119.682 59.5852 118.897 56.3145C117.729 52.0155 114.878 45.9934 114.067 37.7151C113.256 29.4368 114.939 28.0601 114.939 28.0601C114.939 28.0601 116.988 41.3835 118.287 48.8712C119.586 56.359 120.641 64.4063 120.72 66.2627L120.388 66.2804Z"
          fill="#03485C"
        />
        <path
          d="M120.388 66.2804C120.181 62.9202 119.682 59.5852 118.897 56.3145C117.729 52.0155 114.878 46.4019 114.067 38.1237C113.256 29.8454 114.939 28.0601 114.939 28.0601C114.939 28.0601 113.884 34.5974 117.476 47.9119C119.032 53.9319 120.116 60.068 120.72 66.2627L120.388 66.2804Z"
          fill="#006A85"
        />
        <path
          d="M120.24 66.2005C120.24 66.2005 121.182 58.3486 121.461 51.3937C121.74 44.4389 124.669 38.9586 124.905 32.4568C125.14 25.9549 123.065 22.7396 123.065 22.7396C123.065 22.7396 123.405 33.0252 122.01 39.2695C120.615 45.5137 120.798 49.9282 120.763 55.5506C120.734 59.1208 120.443 62.6836 119.891 66.2094L120.24 66.2005Z"
          fill="#006A85"
        />
        <path
          d="M121.252 66.2538C121.252 66.2538 121.531 56.5632 119.891 50.0792C118.339 43.9326 119.115 33.5581 121.068 31.5596C121.068 31.5596 121.173 36.7735 121.347 40.6817C121.522 44.5899 121.749 59.6098 121.522 66.2538H121.252Z"
          fill="#03485C"
        />
        <path
          d="M121.251 66.2538C121.251 66.2538 121.548 56.1813 120.65 49.5729C119.682 42.4671 120.249 34.473 121.068 31.5596C121.068 31.5596 121.173 36.7735 121.347 40.6817C121.522 44.5899 121.748 59.6098 121.522 66.2538H121.251Z"
          fill="#006A85"
        />
        <path
          d="M119.909 66.2981C119.909 66.2981 118.897 59.2367 117.947 55.0354C116.997 50.8341 114.067 46.0377 112.637 41.2768C112.637 41.2768 112.009 46.5529 113.709 50.0436C115.41 53.5343 116.953 54.1738 118.139 58.4284C118.873 61.0019 119.349 63.6445 119.56 66.3159L119.909 66.2981Z"
          fill="#03485C"
        />
        <path
          d="M121.932 66.2626C122.229 63.3415 122.68 60.4387 123.283 57.5669C124.26 53.0369 126.474 51.7668 126.963 45.4337C127.307 42.1256 127.157 38.7834 126.518 35.5211C126.518 35.5211 124.234 47.601 123.763 51.145C123.292 54.689 122.812 58.6505 122.289 61.9903C121.827 65.028 121.6 66.2893 121.6 66.2893L121.932 66.2626Z"
          fill="#03485C"
        />
        <path
          d="M121.932 66.2626C122.229 63.3415 122.68 60.4387 123.283 57.5669C124.26 53.0369 126.474 51.7668 126.963 45.4337C127.307 42.1256 127.157 38.7834 126.518 35.5211C126.625 37.7533 126.546 39.9908 126.283 42.2095C125.999 45.0394 125.5 47.8428 124.792 50.5943C123.668 54.3209 122.831 58.1311 122.289 61.9903C121.827 65.028 121.6 66.2893 121.6 66.2893L121.932 66.2626Z"
          fill="#03485C"
        />
        <path
          d="M125.995 64.526H115.624C115.249 65.302 115.054 66.1531 115.054 67.0154C115.054 68.5433 115.66 70.0086 116.738 71.089C117.816 72.1694 119.279 72.7763 120.803 72.7763C122.328 72.7763 123.791 72.1694 124.869 71.089C125.947 70.0086 126.553 68.5433 126.553 67.0154C126.557 66.154 126.366 65.303 125.995 64.526Z"
          fill="#677A89"
        />
      </g>
      <g clipPath="url(#clip3_6154_90081)">
        <path
          d="M161.011 70.3149H131.819C131.499 70.3149 131.191 70.1863 130.964 69.9574C130.738 69.7285 130.61 69.418 130.61 69.0943L132.614 50.6118C132.614 50.2881 132.741 49.9776 132.968 49.7487C133.195 49.5198 133.503 49.3912 133.823 49.3912H162.998C163.318 49.3912 163.626 49.5198 163.853 49.7487C164.079 49.9776 164.207 50.2881 164.207 50.6118L162.22 69.0943C162.22 69.418 162.093 69.7285 161.866 69.9574C161.64 70.1863 161.332 70.3149 161.011 70.3149Z"
          fill="#F2F5F8"
        />
        <path
          d="M161.011 70.6811H131.819C131.402 70.6811 131.002 70.5139 130.707 70.2164C130.413 69.9188 130.247 69.5152 130.247 69.0944L132.251 50.5595C132.26 50.1448 132.429 49.7501 132.723 49.46C133.017 49.17 133.412 49.0076 133.823 49.0077H162.997C163.206 49.0077 163.413 49.0492 163.605 49.1298C163.798 49.2104 163.973 49.3286 164.121 49.4775C164.268 49.6265 164.386 49.8033 164.465 49.998C164.545 50.1926 164.586 50.4012 164.586 50.6118L162.583 69.1293C162.574 69.544 162.404 69.9387 162.11 70.2288C161.816 70.5188 161.422 70.6812 161.011 70.6811ZM133.823 49.7575C133.598 49.7575 133.383 49.8475 133.224 50.0077C133.065 50.1679 132.976 50.3852 132.976 50.6118L130.99 69.1293C130.999 69.3498 131.092 69.5582 131.25 69.711C131.407 69.8637 131.618 69.9489 131.836 69.9488H161.028C161.138 69.9488 161.248 69.9266 161.349 69.8834C161.451 69.8403 161.543 69.7771 161.621 69.6975C161.698 69.6179 161.758 69.5236 161.799 69.42C161.84 69.3165 161.859 69.2057 161.857 69.0944L163.809 50.5595C163.796 50.3421 163.701 50.138 163.544 49.9889C163.386 49.8398 163.178 49.757 162.963 49.7575H133.823Z"
          fill="#9FAFBC"
        />
        <path
          d="M161.737 70.5767H117.621C117.315 70.5767 117.068 70.8265 117.068 71.1346V71.6228C117.068 71.931 117.315 72.1808 117.621 72.1808H161.737C162.042 72.1808 162.289 71.931 162.289 71.6228V71.1346C162.289 70.8265 162.042 70.5767 161.737 70.5767Z"
          fill="#9FAFBC"
        />
        <path
          opacity="0.5"
          d="M161.892 72.1808H144.118V70.5767H161.892C161.997 70.5767 162.098 70.6189 162.173 70.6941C162.247 70.7693 162.289 70.8713 162.289 70.9777V71.7972C162.289 71.8491 162.279 71.9004 162.259 71.9481C162.239 71.9959 162.209 72.0389 162.172 72.0748C162.135 72.1107 162.091 72.1385 162.043 72.1568C161.994 72.175 161.943 72.1832 161.892 72.1808Z"
          fill="#465967"
        />
        <path
          d="M160.666 51.8845H135.723C135.427 51.8845 135.188 52.1265 135.188 52.425V52.4425C135.188 52.741 135.427 52.983 135.723 52.983H160.666C160.961 52.983 161.201 52.741 161.201 52.4425V52.425C161.201 52.1265 160.961 51.8845 160.666 51.8845Z"
          fill="#32424E"
        />
        <path
          d="M142.131 60.2541H134.514L135.239 54.6047H142.857L142.131 60.2541Z"
          fill="#C3CDD5"
        />
        <path
          d="M157.176 66.845H133.719L134.203 61.1782H157.919L157.176 66.845Z"
          fill="#C3CDD5"
        />
        <path
          d="M151.062 60.2541H143.444L144.17 54.6047H151.805L151.062 60.2541Z"
          fill="#C3CDD5"
        />
      </g>
      <g clipPath="url(#clip4_6154_90081)">
        <path
          d="M182.211 69.8809H170.079V72.1806H182.211V69.8809Z"
          fill="#465967"
        />
        <path
          d="M175.349 53.0204V69.8805H176.942V53.9635L175.349 53.0204Z"
          fill="#677A89"
        />
        <path
          d="M169.018 46.8098L168.405 47.5326L184.322 60.7214L184.935 59.9987L169.018 46.8098Z"
          fill="#677A89"
        />
        <path
          d="M182.265 57.578L181.449 58.54L184.223 60.838L185.038 59.876L182.265 57.578Z"
          fill="#DAEE6B"
        />
        <path
          d="M157.97 51.9543L163.269 52.3606L165.537 57.4825C165.537 57.4825 161.691 56.8876 157.97 51.9543Z"
          fill="#C3CDD5"
        />
        <path
          d="M162.506 56.5248C163.953 56.5248 165.126 55.3652 165.126 53.9348C165.126 52.5044 163.953 51.3448 162.506 51.3448C161.059 51.3448 159.886 52.5044 159.886 53.9348C159.886 55.3652 161.059 56.5248 162.506 56.5248Z"
          fill="#DAEE6B"
        />
        <path
          d="M165.977 46.0343L166.652 45.1129C167.77 45.4919 168.754 46.1822 169.485 47.1007L168.678 48.3558L165.977 46.0343Z"
          fill="#DAEE6B"
        />
        <path
          d="M165.977 46.0341L164.964 47.3762C164.37 47.9276 160.972 48.4934 157.97 51.954C160.739 53.4419 163.285 55.3024 165.537 57.4821C167.958 53.9055 167.511 50.1258 167.929 49.5018L168.868 48.0509C168.132 47.1057 167.124 46.4026 165.977 46.0341Z"
          fill="#111920"
        />
      </g>
      <g clipPath="url(#clip5_6154_90081)">
        <path
          d="M114.331 76.7247H108.947V137.745H114.331V76.7247Z"
          fill="#9FAFBC"
        />
        <path
          d="M127.136 76.7247H121.753V137.745H127.136V76.7247Z"
          fill="#677A89"
        />
        <path
          d="M168.323 76.7247H162.939V137.745H168.323V76.7247Z"
          fill="#9FAFBC"
        />
        <path
          d="M181.129 76.7247H175.745V137.745H181.129V76.7247Z"
          fill="#677A89"
        />
        <path
          d="M185.711 74.3702H104.382V78.1477H185.711V74.3702Z"
          fill="#9FAFBC"
        />
        <path
          d="M165.501 72.2091H102.03V74.3702H165.501H188.045V72.2091H165.501Z"
          fill="#C3CDD5"
        />
      </g>
      <g opacity="0.5" clipPath="url(#clip6_6154_90081)">
        <path
          d="M73.5806 3.24828L136.458 29.9141C145.875 33.9087 156.073 35.7444 166.298 35.2855L170.358 35.0944C186.074 34.3766 201.501 39.4693 213.676 49.3938C225.85 59.3184 233.913 73.3747 236.315 88.8613L236.667 91.133C238.609 103.669 236.495 116.495 230.632 127.756C224.769 139.016 215.461 148.125 204.055 153.766C192.649 159.406 179.737 161.285 167.188 159.13C154.638 156.975 143.103 150.898 134.252 141.779L124.405 131.641C119.97 127.071 114.61 123.494 108.68 121.145C102.751 118.797 96.3881 117.733 90.014 118.022L34.0213 120.538C13.2079 121.472 2.04994 96.515 16.5969 81.696C19.4153 78.8306 21.4269 75.2767 22.4296 71.3916C23.4323 67.5065 23.3908 63.427 22.3091 59.5629L19.7195 50.2745C10.8102 18.3222 42.9413 -9.74494 73.5806 3.24828Z"
          fill="#EBF7CE"
        />
      </g>
      <g clipPath="url(#clip7_6154_90081)">
        <path
          d="M93.3814 83.27C93.2771 82.7627 93.0038 82.3076 92.6077 81.9812C92.2116 81.6549 91.7168 81.4773 91.2069 81.4784L64.2472 79.7722C62.2657 73.937 60.5361 69.0147 60.259 68.7502C60.259 68.7502 54.7344 65.6194 52.0729 67.2232C49.4113 68.827 50.2341 70.9683 50.2341 70.9683L54.8099 83.5942L59.646 96.2541L62.7779 101.663L70.8716 99.6921C70.8716 99.6921 68.017 90.9564 65.2631 82.7752C72.7271 82.7752 87.9324 82.9799 90.1405 84.9932C91.6099 86.307 93.2807 101.663 93.2807 101.663H97C97.3611 97.5508 93.7928 84.6435 93.3814 83.27Z"
          fill="#677A89"
        />
        <path
          d="M96.7314 106.568H101.232L104.439 139.549H102.659L96.7314 106.568Z"
          fill="#677A89"
        />
        <path
          d="M73.8859 106.568H69.3856L65.2883 139.549H67.0599L73.8859 106.568Z"
          fill="#677A89"
        />
        <path
          d="M62.7778 101.646L68.0673 98.677L100.585 101.646H62.7778Z"
          fill="#677A89"
        />
        <path
          d="M101.215 106.568H90.9465V101.646H100.585L101.215 106.568Z"
          fill="#677A89"
        />
        <path
          d="M94.1539 106.568H58.6218V101.646H93.2891L94.1539 106.568Z"
          fill="#C3CDD5"
        />
        <path
          d="M63.1219 106.568H58.6216L55.4143 139.549H57.1859L63.1219 106.568Z"
          fill="#C3CDD5"
        />
        <path
          d="M89.6367 106.568H94.137L95.0354 139.549H93.2638L89.6367 106.568Z"
          fill="#C3CDD5"
        />
        <path
          d="M60.259 68.7331C60.259 68.7331 56.3043 64.7151 51.6613 66.0288C50.4523 66.3701 48.1183 68.1786 49.5456 72.3332C50.9729 76.4878 58.6217 101.646 58.6217 101.646H62.8197C62.8197 101.646 52.1148 74.2783 51.5018 71.6422C50.8889 69.0062 53.0971 65.2013 60.259 68.7331Z"
          fill="#C3CDD5"
        />
        <path
          d="M52.5564 79.599C52.5564 79.599 84.2634 81.76 85.145 81.8282C85.6564 81.8251 86.1532 82.0018 86.551 82.3283C86.9489 82.6548 87.2234 83.111 87.328 83.6197C87.7394 85.0188 90.9466 101.995 90.9466 101.995C90.7182 101.995 91.3744 106.115 91.178 106.115C90.3874 106.115 88.3504 106.115 87.4311 106.115L87.2273 101.995C87.2273 101.995 85.6488 85.2662 83.2307 85.2662L53.3457 82.8834L52.5564 79.599Z"
          fill="#C3CDD5"
        />
      </g>
      <g clipPath="url(#clip8_6154_90081)">
        <g clipPath="url(#clip9_6154_90081)">
          <path
            d="M70.5998 39.5604C70.5998 39.5604 72.0425 39.5048 71.6878 35.5912C71.4174 33.928 68.5798 33.4242 68.5128 36.5515C68.3677 40.2891 65.8779 39.0786 65.2315 38.692C65.0145 39.7882 63.2561 43.875 62.9207 45.0129C65.9598 45.851 68.4405 48.8437 69.6997 50.8872C69.8715 49.8019 71.1098 45.1189 71.2653 44.2548C70.8008 43.5682 70.4998 42.7898 70.3846 41.9772C70.2694 41.1646 70.3429 40.3386 70.5998 39.5604Z"
            fill="#A28370"
          />
          <path
            d="M76.09 41.8144C75.9433 42.7404 77.9245 42.6552 77.9245 42.6552C78.06 42.5398 78.1674 42.3964 78.2391 42.2353C78.3108 42.0741 78.3449 41.8993 78.339 41.7232C77.5988 41.7329 76.2203 41.0309 76.09 41.8144Z"
            fill="#A28370"
          />
          <path
            d="M79.8423 38.4244C79.5184 37.6349 79.3771 36.7866 79.4288 35.9405C80.4103 34.8384 80.1531 32.8569 79.8662 31.6506L79.7749 31.6784C79.7266 31.6949 79.6768 31.7072 79.6263 31.7154L79.5899 31.7096C79.4949 31.7254 79.3969 31.7099 79.3114 31.6655C78.9761 31.431 76.4193 30.095 75.823 30.1758C73.5398 30.5216 75.3343 32.5169 75.1853 33.4183C75.0363 34.3198 72.9946 34.3168 73.2103 37.4224C73.2891 38.4929 71.916 40.186 73.5725 41.3674C74.8936 42.3142 75.4255 41.4251 75.4255 41.4251C75.7147 40.8148 76.2347 40.3385 76.8776 40.0952C77.1694 39.9423 77.496 39.8623 77.8284 39.8622C78.1608 39.8621 78.4888 39.942 78.7833 40.0947L78.8001 39.9885C79.6609 40.0402 80.4034 40.055 79.8423 38.4244Z"
            fill="#A28370"
          />
          <path
            d="M77.7996 36.3899C78.0002 36.4217 78.188 36.289 78.2189 36.0935C78.2499 35.8981 78.1123 35.7139 77.9117 35.6821C77.711 35.6503 77.5232 35.783 77.4923 35.9785C77.4613 36.1739 77.5989 36.3581 77.7996 36.3899Z"
            fill="#1C262F"
          />
          <path
            d="M79.2728 35.7102L75.6507 34.3204C75.6507 34.3204 79.563 34.5833 79.4972 34.9598C79.4513 35.2175 79.3761 35.4692 79.2728 35.7102Z"
            fill="#30424E"
          />
          <path
            d="M75.9175 30.2452C76.4835 30.1595 79.0058 31.478 79.3351 31.7115C79.6643 31.945 80.7466 31.4998 81.0831 30.0416C81.4196 28.5833 79.9989 25.1297 76.8657 25.3167C74.6846 25.4489 74.2203 26.3427 73.3456 25.9079C71.0646 24.6337 68.4213 25.9986 68.4213 25.9986C65.6919 27.5555 64.0847 29.8644 64.194 32.5843L65.0932 38.664C65.0932 38.664 68.4518 40.9734 68.6054 36.7111C68.6636 33.6006 71.3424 34.049 71.6146 35.7004C71.9661 39.5953 70.5118 39.5282 70.5118 39.5282C70.5118 39.5282 69.1712 43.6812 73.0115 45.9279C76.5225 47.9411 78.7726 47.6082 77.9567 42.6482C77.9567 42.6482 76.0337 42.7185 76.1832 41.8534C76.3326 40.9883 78.1498 42.056 78.6903 41.7002C78.8732 41.5086 79.0007 41.2728 79.0598 41.0168C79.1188 40.7608 79.1075 40.4935 79.0268 40.242C78.8611 39.9558 78.0451 39.5424 76.9628 39.9877C76.3001 40.2381 75.7495 40.7069 75.4059 41.3131C75.4059 41.3131 74.9761 42.2244 73.6651 41.2913C72.0311 40.1256 73.3883 38.4542 73.3137 37.3964C73.0905 34.338 75.1126 34.3076 75.257 33.4357C75.4013 32.5637 73.6362 30.5792 75.9175 30.2452Z"
            fill="#30424E"
          />
          <path
            opacity="0.3"
            d="M77.7783 28.4117C76.8882 28.2707 73.2642 30.0668 71.7688 28.0645C75.3579 29.4673 76.1606 26.9463 78.1589 27.2627C79.7333 27.5121 80.7354 29.3758 80.6653 31.0334C80.5544 31.2276 80.4021 31.396 80.2186 31.5275C80.035 31.659 79.8245 31.7505 79.601 31.7959C79.6086 31.7649 79.6136 31.7334 79.616 31.7016C79.748 29.1046 78.9591 28.5987 77.7783 28.4117Z"
            fill="white"
          />
        </g>
        <g clipPath="url(#clip10_6154_90081)">
          <path
            d="M105.659 138.091L120.161 139.297V139.753H108.527L105.659 139.272V139.753H101.123V138.847L105.659 138.091Z"
            fill="black"
          />
          <path
            d="M128.933 139.026L143.435 140.232V140.688H131.801L128.933 140.207V140.688H124.397V139.776L128.933 139.026Z"
            fill="black"
          />
          <path
            d="M110.445 128.631L107.302 137.047L103.609 134.935L105.302 127.406L110.445 128.631Z"
            fill="#D147AF"
          />
          <path
            d="M126.509 126.636L131.951 135.246L127.971 136.733L122.279 129.81L126.509 126.636Z"
            fill="#D147AF"
          />
          <path
            d="M108.745 133.261L114.287 136.916C114.287 136.916 120.123 137.86 120.161 138.853V139.303H108.676L105.652 138.809L101.116 138.853C101.116 137.835 103.466 134.767 103.466 134.767H106.121L108.745 133.261Z"
            fill="#465967"
          />
          <path
            d="M132.019 134.19L137.561 137.845C137.561 137.845 143.397 138.795 143.435 139.782V140.232H131.951L128.927 139.739L124.39 139.782C124.39 138.77 126.74 135.696 126.74 135.696H129.383L132.019 134.19Z"
            fill="#465967"
          />
          <path
            d="M112.219 135.567L110.957 135.942"
            stroke="black"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M111.213 134.898L109.958 135.267"
            stroke="black"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M110.207 134.223L108.951 134.592"
            stroke="black"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M135.494 136.502L134.232 136.871"
            stroke="black"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M134.488 135.827L133.232 136.202"
            stroke="black"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M133.481 135.152L132.226 135.527"
            stroke="black"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M82.6163 83.9973C82.6163 83.9973 111.464 88.8584 113.894 89.2395C115.863 89.5519 119.424 91.0202 120.567 93.2758C121.711 95.5314 120.393 97.2371 119.224 101.586C116.637 111.22 111.631 130.212 111.631 130.212C111.631 130.212 105.383 130.837 102.677 130.087L109.165 100.88L95.2375 91.9199L81.3354 90.2579L82.6163 83.9973Z"
            fill="#111920"
          />
          <path
            d="M71.0635 100.786C71.0635 100.786 73.7591 101.162 107.628 101.162L123.449 135.115C123.449 135.115 129.241 132.891 130.754 129.973L118.399 97.7244C118.399 97.7244 117.15 95.0564 116.606 94.5504C114.952 92.9643 112.868 91.8996 110.614 91.4888C106.24 90.7327 84.0533 86.584 84.0533 86.584L72.8754 90.2079L71.0635 100.786Z"
            fill="#202E39"
          />
          <path
            d="M71.9069 48.7659C71.9069 48.7659 74.4686 51.8587 74.4061 54.5954L70.6572 50.4216L71.9069 48.7659Z"
            fill="#EA7BCE"
          />
          <path
            d="M61.366 45.2107L61.7533 43.2925C68.0015 42.6115 72.5439 49.4532 71.9503 48.9533L70.3008 50.8278L61.366 45.2107Z"
            fill="#DEE4E8"
          />
          <path
            d="M61.4473 44.4921C65.1962 44.5234 69.7761 48.4909 75.7243 55.9137C77.0177 57.5195 79.9168 65.4421 79.9168 65.4421L87.0834 95.858C87.0834 95.858 88.0206 100.557 83.7469 101.481C80.9602 102.106 73.2875 103.631 68.0641 104.249C65.2774 104.58 62.547 96.5016 61.6535 88.6289C61.0849 83.6304 58.2983 70.6218 58.2983 70.6218C58.2983 70.6218 56.1614 57.0071 57.1986 52.9209C58.1342 50.9471 59.2511 49.0646 60.5351 47.2975L61.4473 44.4921Z"
            fill="#006A85"
          />
          <path
            d="M57.5546 61.3246C57.5546 61.3246 61.7221 76.0327 63.734 80.9125C65.8147 85.9547 70.6944 82.7494 70.6944 82.7494L92.1505 72.515L89.1264 66.9229L71.7566 72.9899C71.7566 72.9899 70.607 49.9405 63.6341 50.909C63.5903 50.9215 55.6927 50.3279 57.5546 61.3246Z"
            fill="#00819D"
          />
          <path
            d="M60.5103 47.3725C63.5781 46.8726 66.2898 48.897 66.2898 48.897L68.4704 49.2219L68.2579 51.0464C72.3218 53.5425 75.7166 56.9909 78.1487 61.0934"
            stroke="black"
            strokeWidth="0.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M82.4722 82.9493C82.4722 82.9493 76.8863 83.6866 74.4246 84.7676"
            stroke="black"
            strokeWidth="0.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M75.6245 59.2065C75.6245 59.2065 72.9066 58.7129 71.6882 59.0815"
            stroke="black"
            strokeWidth="0.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M82.4348 82.993C82.6035 84.955 82.6472 85.9609 81.4163 86.1608L75.5056 87.0981"
            stroke="black"
            strokeWidth="0.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M88.8205 72.6336C88.9758 72.6336 89.1016 72.5077 89.1016 72.3525C89.1016 72.1972 88.9758 72.0713 88.8205 72.0713C88.6652 72.0713 88.5393 72.1972 88.5393 72.3525C88.5393 72.5077 88.6652 72.6336 88.8205 72.6336Z"
            fill="black"
          />
          <path
            d="M89.6703 72.2401C89.8256 72.2401 89.9515 72.1142 89.9515 71.9589C89.9515 71.8036 89.8256 71.6777 89.6703 71.6777C89.515 71.6777 89.3892 71.8036 89.3892 71.9589C89.3892 72.1142 89.515 72.2401 89.6703 72.2401Z"
            fill="black"
          />
          <path
            d="M87.9645 73.0273C88.1198 73.0273 88.2457 72.9014 88.2457 72.7461C88.2457 72.5908 88.1198 72.465 87.9645 72.465C87.8092 72.465 87.6833 72.5908 87.6833 72.7461C87.6833 72.9014 87.8092 73.0273 87.9645 73.0273Z"
            fill="black"
          />
          <path
            d="M96.1242 68.1351L89.1763 65.6796L94.4559 46.929L101.404 47.7225L96.1242 68.1351Z"
            fill="#9FAFBC"
          />
          <path
            d="M95.9618 67.1666L89.7949 64.9173L94.481 48.0911L100.648 48.9845L95.9618 67.1666Z"
            fill="#32424E"
          />
          <path
            d="M90.4137 66.0232C90.4137 66.0232 91.1884 65.0548 91.4446 64.8298C91.7008 64.6049 93.0379 64.0301 93.3191 63.8489C93.6002 63.6677 94.275 63.6739 94.7499 63.3803C95.2247 63.0866 95.6933 62.5055 95.9495 63.424C96.2057 64.3425 91.2009 65.9233 90.951 65.9233C90.881 65.9079 90.8085 65.9077 90.7384 65.9228C90.6683 65.9379 90.6023 65.9679 90.5449 66.0107C90.5449 66.0107 90.2075 66.2482 90.4137 66.0232Z"
            fill="#A28370"
          />
          <path
            d="M91.6072 71.5404C92.7381 71.203 94.4313 70.6907 95.1061 70.4157C96.0321 69.977 96.9239 69.4695 97.7741 68.8975C97.9121 68.6842 98.0006 68.4428 98.0331 68.1908C98.0655 67.9389 98.0411 67.6829 97.9615 67.4416C98.1177 67.4416 97.9615 66.5044 97.5117 66.3857C97.5929 66.3357 98.1365 65.0236 97.0555 64.8737C96.4307 65.1736 95.4935 65.7609 95.3935 65.8171C95.2936 65.8734 94.8562 66.0546 94.8062 65.9796C94.7562 65.9046 95.2248 65.6797 95.2248 65.6797L96.4307 64.9236L97.0555 64.5425C97.0555 64.5425 97.243 64.3051 97.1993 64.2363C97.1555 64.1676 96.8244 63.3804 96.5744 63.4366C96.4593 63.4323 96.3445 63.4514 96.237 63.4928C95.7934 63.699 95.1561 64.0239 94.8937 64.1739C94.6313 64.3238 93.1942 64.73 92.8755 64.8862C92.1733 65.2583 91.4445 65.5778 90.6949 65.8421C90.4513 65.8921 89.8764 66.6731 89.3953 67.3667C89.3641 67.3917 91.6072 71.5404 91.6072 71.5404Z"
            fill="#A28370"
          />
          <path
            d="M97.5181 66.4105L96.0623 67.1291C95.6745 67.2975 95.3059 67.507 94.9626 67.7539"
            stroke="#624834"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M97.9991 67.4666C97.9381 67.5153 97.8733 67.5591 97.8054 67.5978C97.3868 67.8602 96.6558 68.2976 96.4434 68.3975L95.2625 68.9724"
            stroke="#624834"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M96.0371 63.574C94.5091 64.2296 93.0159 64.9637 91.5635 65.7733"
            stroke="#624834"
            strokeWidth="0.1"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </g>
      </g>
      <path
        d="M52.5564 79.599C52.5564 79.599 84.2634 81.76 85.145 81.8282C85.6564 81.8251 86.1532 82.0018 86.551 82.3283C86.9489 82.6548 87.2234 83.111 87.328 83.6197C87.7394 85.0188 90.9466 101.995 90.9466 101.995C90.7182 101.995 91.3744 106.115 91.178 106.115C90.3874 106.115 88.3504 106.115 87.4311 106.115L87.2273 101.995C87.2273 101.995 85.6488 85.2662 83.2307 85.2662L53.3457 82.8834L52.5564 79.599Z"
        fill="#C3CDD5"
      />
      <defs>
        <clipPath id="clip0_6154_90081">
          <rect
            width="9.02255"
            height="21.0526"
            fill="white"
            transform="translate(157.368 51.1279)"
          />
        </clipPath>
        <clipPath id="clip1_6154_90081">
          <rect
            width="9.02256"
            height="21.0526"
            fill="white"
            transform="translate(104.436 51.7294)"
          />
        </clipPath>
        <clipPath id="clip2_6154_90081">
          <rect
            width="51.7293"
            height="51.7293"
            fill="white"
            transform="translate(94.812 21.0527)"
          />
        </clipPath>
        <clipPath id="clip3_6154_90081">
          <rect
            width="47.5188"
            height="40.3008"
            fill="white"
            transform="translate(117.068 31.8798)"
          />
        </clipPath>
        <clipPath id="clip4_6154_90081">
          <rect
            width="27.0677"
            height="27.0677"
            fill="white"
            transform="translate(157.97 45.1129)"
          />
        </clipPath>
        <clipPath id="clip5_6154_90081">
          <rect
            width="86.015"
            height="86.015"
            fill="white"
            transform="translate(102.03 51.7294)"
          />
        </clipPath>
        <clipPath id="clip6_6154_90081">
          <rect
            width="227.368"
            height="160"
            fill="white"
            transform="translate(10)"
          />
        </clipPath>
        <clipPath id="clip7_6154_90081">
          <rect
            width="55.3383"
            height="83.0075"
            fill="white"
            transform="translate(49.0977 56.5413)"
          />
        </clipPath>
        <clipPath id="clip8_6154_90081">
          <rect
            width="108.271"
            height="129.925"
            fill="white"
            transform="translate(53.3081 15.639)"
          />
        </clipPath>
        <clipPath id="clip9_6154_90081">
          <rect
            width="21.6541"
            height="28.8722"
            fill="white"
            transform="translate(65.8958 21.0526) rotate(9)"
          />
        </clipPath>
        <clipPath id="clip10_6154_90081">
          <rect
            width="101.053"
            height="105.263"
            fill="white"
            transform="translate(53.3081 40.2373)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IllustrationItalyBilling;
